import _ from '@/common/helpers';

const escapeQueryPattern = /[\\^$.*+?()[\]{}|]/g;

export default function filterArrayByQuery({array, term, value = v => v}) {
    let query = term;
    if (_.isBlank(query)) {
        return [];
    }
    const escapeQueryRegexp = new RegExp(escapeQueryPattern.source);
    if (escapeQueryRegexp.test(query)) {
        query = query.replace(escapeQueryPattern, '');
    }
    const regexp = new RegExp(`.*(${query.trim()}).*`, 'i');
    return array.filter(item => regexp.test(value(item)));
}
